/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useState } from "react";
import "./PassesScreen.css";
import backIcon from "../../assets/images/back-icon.svg";
import { useNavigate } from "react-router-dom";
import { CALENDAR_RESERVATION_TYPE } from "utils/constants";
import CalendarTableContainer from "screens/Calendar Screen/Views/CalendarTableContainer";
import { highlightLastWord } from "utils/utils";

const PassesScreen: FC = () => {
  const navigate = useNavigate();
  const [selectedPassData, setSelectedPassData] = useState<any>(null);

  useEffect(() => {
    const storedPassData = localStorage.getItem("selectedPassData");
    if (storedPassData) {
      setSelectedPassData(JSON.parse(storedPassData));
    }
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="wms-mobile-container">
      <div className="passes-screen-container">
        <div className="passes-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>{highlightLastWord(selectedPassData?.title ?? "")}</span>
        </div>
        {selectedPassData && (
          <CalendarTableContainer
            selectedTab={CALENDAR_RESERVATION_TYPE.EVENTS}
            showMonthView={true}
            passId={selectedPassData?.id}
          ></CalendarTableContainer>
        )}
      </div>
    </div>
  );
};

export default PassesScreen;
